export const MEASUREMENT_A = 'measurement_a';
export const MEASUREMENT_B = 'measurement_b';
export const MEASUREMENT_C = 'measurement_c';
export const MEASUREMENT_D = 'measurement_d';
export const MEASUREMENT_E = 'measurement_e';
export const QUANTITY_HEADING = 'quantity_heading';
export const LENGTHS = 'lengths';
export const TOTAL_FEET = 'total_feet';
export const DISPLAY_A = 'displayMeasurementA';
export const DISPLAY_B = 'displayMeasurementB';
export const DISPLAY_C = 'displayMeasurementC';
export const DISPLAY_D = 'displayMeasurementD';
export const DISPLAY_E = 'displayMeasurementE';
